export default function FaqPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-indigo-100 via-purple-100 to-pink-100">
      <h1 className="text-4xl font-bold mb-4">Frequently Asked Questions</h1>
      <p className="text-lg text-gray-700 mb-8">Find answers to the most common questions about Inflatein AI Studio.</p>
    </div>
  )
}
